import { Expose } from "class-transformer";
import { Model } from "./model";

export class RateCriterionModel extends Model {
    @Expose({ name: '_id'}) id: string;
    @Expose() name: string;
    @Expose() reviewerComment: string;   
}